import { Theme } from '@mui/material/styles';

/**
 * Shared chip/colour resolution for run-progress surfaces.
 *
 * Lifted from the lottery implementation (DD-029) so the campaign run screen and
 * the lottery run screen address the palette the same way. Colours are always
 * theme paths, never literals (DD-013).
 */
export interface ChipColour {
  background: string;
  color: string;
}

export interface ChipStyle {
  backgroundColor: string;
  color: string;
  fontSize: number;
  height: number;
  '& .MuiChip-label': { px: number };
}

export function resolveThemeColour(theme: Theme, path: string): string {
  const segments = path.split('.');
  let current: unknown = theme.palette;
  for (const segment of segments) {
    if (current && typeof current === 'object') {
      current = (current as Record<string, unknown>)[segment];
    } else {
      return path;
    }
  }
  return typeof current === 'string' ? current : path;
}

export function resolveChipColours(theme: Theme, colour: ChipColour): ChipStyle {
  return {
    backgroundColor: resolveThemeColour(theme, colour.background),
    color: resolveThemeColour(theme, colour.color),
    fontSize: 11,
    height: 22,
    '& .MuiChip-label': { px: 1 },
  };
}
